import { useNavigate } from 'react-router-dom';
import { useTranslatedText } from '../i18n/useTranslatedText.js';
import './CreateContent.css';

const CreateContent = () => {
  const navigate = useNavigate();

  const createEventTitle = useTranslatedText('Etkinlik Oluştur');
  const createEventDesc = useTranslatedText('Bir Etkinlik Planlayın ve Düzenleyin');
  const createResourceTitle = useTranslatedText('Kaynak Oluştur');
  const createResourceDesc = useTranslatedText('Yeni Kaynak Materyallari Yayınla');

  return (
    <div className="create-content-container">
      <div className="create-content-options">
        <div className="create-content-box" onClick={() => navigate('/etkinlik-oluştur')}>
          <h3>{createEventTitle}</h3>
          <p>{createEventDesc}</p>
        </div>
        <div className="create-content-box" onClick={() => navigate('/resource-oluştur')}>
          <h3>{createResourceTitle}</h3>
          <p>{createResourceDesc}</p>
        </div>
      </div>
    </div>
  );
};

export default CreateContent;

